import React from 'react';
import StaffListChooseUI from '../../QuickBooking/StaffListChooseUI';
import { IStaffItemData } from 'services/shop/types/staff';
import appointmentSelectors from 'features/appointment/services/selectors';
type Props = {
  value?: IStaffItemData;
  onChange?: (value: IStaffItemData) => void;
  onPickStaff?: (value: IStaffItemData) => void;
  staffs?: IStaffItemData[];
};
const StaffChoose = ({ value, onChange = () => undefined, onPickStaff = () => undefined, staffs }: Props) => {
  const visibleAnybodyBooking = appointmentSelectors.visibleAnybodyBooking();
  const _onPickStaff = (value: IStaffItemData) => {
    onChange(value);
    onPickStaff(value);
  };
  return (
    <StaffListChooseUI staffs={staffs} anybody={visibleAnybodyBooking} onPickStaff={_onPickStaff} selectedStaffs={value ? [value?.id] : []} />
  );
};

export default StaffChoose;
